<h2 class="text-center">Come to a show!</h2>
<div class="container p-5" data-aos="fade-down">
  <!-- for each show -->
  @for (show of shows; track show; let last = $last) {
    <div>
      <app-show-big [show]="show"></app-show-big>
      @if (!last) {
        <hr class="styled-line" />
      }
    </div>
  }
</div>
